import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@config/server/apiClient';
import { queries } from '@config/server/queryKeys';

/**
 * Response type for completing email verification
 */
export interface CompleteEmailVerificationResponse {
	success: true;
	message: string;
}

/**
 * API function to complete email verification and advance to MFA step
 */
export const completeEmailVerification = async (): Promise<CompleteEmailVerificationResponse> => {
	const response = await apiClient.post<CompleteEmailVerificationResponse>(
		`/admin_portal/setup/complete-email-verification`,
	);
	return response.data;
};

/**
 * Hook for completing email verification (advances onboarding state to NEEDS_MFA)
 * Invalidates /me query on success to trigger guard-based routing
 */
export const useCompleteEmailVerification = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: completeEmailVerification,
		onSuccess: () => {
			// Invalidate /me query to refresh user data with updated onboarding state
			// The InviteAuthGuard will automatically route based on the new onboarding state
			queryClient.invalidateQueries({
				queryKey: queries.auth.me.queryKey,
			});
		},
	});
};
